import "./App.css";
import React from "react";
import ChatComponent from "./components/ChatComponent";
import BackGroundVideo from "./components/BackGroundVideo";

const App = () => {
  return (
    <>
      <BackGroundVideo></BackGroundVideo>
      <ChatComponent></ChatComponent>
    </>
  );
};

export default App;
